<template>
    <div>
        <el-dialog
                :visible.sync="dialogVisible"
                width="80%"
        >
            <el-form>
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <p style="text-align: center">
                                <span style="font-size: 24px">合同归档</span>
                            </p>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <table width="100%" border="0" cellpadding="0" class="main-table">
                            <tr>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">登记人：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-input
                                            disabled
                                            v-model="htgd.djr"
                                            placeholder="请输入内容">
                                    </el-input>
                                </td>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">登记日期：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-date-picker
                                            disabled
                                            v-model="htgd.djrq"
                                            placeholder="请输入内容">
                                    </el-date-picker>
                                </td>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">合同号：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-input
                                            disabled
                                            v-model="htgd.hth"
                                            placeholder="请输入内容">
                                    </el-input>
                                </td>
                            </tr>
                            <tr>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">开始日期：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-date-picker
                                            disabled
                                            v-model="htgd.ksrq"
                                            placeholder="请输入内容">
                                    </el-date-picker>
                                </td>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">结束日期：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-date-picker
                                            disabled
                                            v-model="htgd.jsrq"
                                            placeholder="请输入内容">
                                    </el-date-picker>
                                </td>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">门店：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-input
                                            disabled
                                            v-model="htgd.md"
                                            placeholder="请输入内容">
                                    </el-input>
                                </td>
                            </tr>
                            <tr>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">品牌：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-input
                                            disabled
                                            v-model="htgd.pp"
                                            placeholder="请输入内容">
                                    </el-input>
                                </td>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">合同编号：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-input
                                            disabled
                                            v-model="htgd.htbh"
                                            placeholder="请输入内容">
                                    </el-input>
                                </td>
                                <td width="10%" class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">纸质合同位置：</span></td>
                                <td width="23.333%" class="main-field">
                                    <el-input
                                            required="required"
                                            v-model="htgd.zzhtwz"
                                            placeholder="请输入内容"
                                            validate="required">
                                    </el-input>
                                </td>
                            </tr>
                            <tr>
                                <td class="main-title"><span
                                        style="color:#969799;margin-left: 5px;">合同文档：</span></td>
                                <td class="main-field" colspan="5">
                                    <EipAttachment v-model="htgd.htwd"
                                                   limit="5" :multiple="true">
                                        <span slot="labeldesc">合同文档</span>↵
                                    </EipAttachment>
                                </td>
                            </tr>
                        </table>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="right" style="padding-top:10px">
                        <el-button type="primary" @click="saveContract">保存</el-button>
                        <el-button @click="close">关闭</el-button>
                    </el-col>
                </el-row>
            </el-form>

        </el-dialog>
    </div>
</template>
<script>
    import EipAttachment from "@/components/eipControl/EipAttachment.vue";
    import req from "@/request.js";
    import utils from "@/utils.js";
    import fUtils from "@/fUtils.js";

    export default {
        name: "contract-upload",
        props: {
            title: {
                type: String,
                required: false,
                efault: "合同上传"
            },
            boData: {
                type: Object,
                required: false
            }

        },
        data() {
            return {
                htgd: {},
                dialogVisible: false
            }
        },
        components: {
            EipAttachment
        },
        watch: {
            dialogVisible: function (newVal) {
                if (newVal) {
                    this.init();
                }
            }
        },
        methods: {
            saveContract() {
                if (!this.htgd.zzhtwz || !this.htgd.htwd) {
                    this.$message({type: "warning", message: "请完善归档合同信息"})
                    return;
                }
                //添加
                let postParams = {
                    htgd: this.htgd
                }
                req.post(window.context.form + "/form/dataTemplate/v1/boSave/htgd?delDraftId=", postParams).then(resp => {
                    if (resp.data.state) {
                        this.$message({
                            type: "success",
                            message: "合同归档成功"
                        });
                        req.post(window.context.form + "/bpm/aliasScript/v1/execute/insertHtbh", {id: this.htgd.gys}).then(resp => {
                            debugger;
                        });
                        this.dialogVisible = false;
                    }
                })
            },
            close() {
                this.dialogVisible = false;
            },
            init() {
                //初始化数据
                let this_ = this;
                let bussinessKey = fUtils.getOnlineFormData().id_;
                if (!bussinessKey) return;
                let formContent = fUtils.getByComponentsName("formContent");
                if (formContent) {
                    if(!formContent.tasks || !formContent.tasks.bpmTask) return ;
                    let procName = formContent.tasks.bpmTask.procDefName;
                    let contractProcNames = [
                        "租赁合同签订", "租赁合同变更", "租赁合同主体变更", "租赁合同移位签订",
                        "联营合同签订", "联营合同变更", "联营合同主体变更", "联营合同移位签订"
                    ]
                    for (let i = 0; i < contractProcNames.length; i++) {
                        if (procName == contractProcNames[i]) {
                            req.post(window.context.bpmRunTime + "/bpm/aliasScript/v1/execute/getHtgd", {id: bussinessKey}).then(resp => {
                                if (resp.data.state && resp.data.value) {
                                    //this.htgd = resp.data.value;
                                    let rep = resp.data.value;
                                    /*this_.htgd.djr = rep.F_DJR;
                                    this_.htgd.djrid = rep.F_DJRID;
                                    this_.htgd.id_ = rep.ID_;
                                    this_.htgd.djrq = new Date(rep.F_DJRQ).format("yyyy-MM-dd");
                                    this_.htgd.gys = rep.F_GYS;
                                    this_.htgd.ksrq = new Date(rep.F_KSRQ).format("yyyy-MM-dd");
                                    this_.htgd.jsrq = new Date(rep.F_JSRQ).format("yyyy-MM-dd");
                                    this_.htgd.md = rep.F_MD;
                                    this_.htgd.htbh = rep.F_HTBH;
                                    this_.$forceUpdate();*/
                                    Object.keys(rep).forEach(key => {
                                        this_.htgd[key.replace("F_", "").toLowerCase()] = rep[key];
                                    })
                                    this_.htgd.djrq = new Date(this.htgd.djrq).format("yyyy-MM-dd");
                                    this_.htgd.ksrq = new Date(this.htgd.ksrq).format("yyyy-MM-dd");
                                    this_.htgd.jsrq = new Date(this.htgd.jsrq).format("yyyy-MM-dd");
                                    this_.$forceUpdate();

                                }
                            })
                            this.htgd.djr = this.$store.state.login.currentUser.username;
                            this.htgd.djrid = this.$store.state.login.currentUser.userId;
                            this.htgd.djrq = utils.getNowFormatDate();
                            this.htgd.gys = bussinessKey;
                            break;
                        }
                    }
                } else {
                    return;
                }
            }
        },
        mounted() {
            this.init();
        }

    }
</script>
<style lang="stylus" scoped>
    .el-date-editor {
        width: 100%
    }
</style>